<template>
    <div class="exposition position-relative">
        <UIGridContainer>
            <UIGridRow>
                <UIGridCol>
                    <UIBlurImage
                        class="back-image"
                        :src="'images/about-page/about-office-03.png'"
                        :resource="true"
                        :responsive-widths="[600, 250]"
                        sizes="(max-width: 556px) 250px, 600px"
                        alt="Office image 3"
                    />
                    <div class="quote">
                        <h1 class="mt-0">"MAKE IT POSSIBLE - <br />&nbsp;MAKE IT DIGITAL"</h1>
                    </div>
                    <UIImage
                        class="overlay-image"
                        :src="'images/about-page/about-office-04.png'"
                        :resource="true"
                        :responsive-widths="[224, 560]"
                        sizes="(max-width: 768px) 224px, 560px"
                        alt="Office image 4"
                    />
                    <nuxt-resource class="hexagon" src="images/about-page/hexagon-yellow.svg" alt="Yellow hexagon" />
                </UIGridCol>
            </UIGridRow>
            <UIGridRow class="bottom-images">
                <UIGridCol md="6" class="pl-0 pl-md-1 left-column">
                    <UIImage
                        class="left-img"
                        src="images/about-page/about-office-05.png"
                        :resource="true"
                        :width="600"
                        alt="Office image 5"
                    />
                    <nuxt-resource
                        class="hexagon green"
                        src="images/about-page/hexagon-green.svg"
                        alt="Green hexagon"
                    />
                </UIGridCol>
                <UIGridCol md="6" class="mt-5 mt-md-0 pr-md-0 d-flex justify-content-center justify-content-md-end">
                    <a @click.prevent="navigateToWorld()">
                        <UIBlurImage
                            class="right-img mr-md-0"
                            :src="'images/about-page/about-sm-01.png'"
                            :resource="true"
                            :width="357"
                            alt="Dundle world"
                        />
                    </a>
                </UIGridCol>
            </UIGridRow>
        </UIGridContainer>
    </div>
</template>

<script>
import { UIGridContainer, UIGridRow, UIGridCol, UIBlurImage, UIImage } from '@dundle/ui/components';
export default {
    components: {
        UIGridRow,
        UIGridCol,
        UIBlurImage,
        UIImage,
        UIGridContainer,
    },
    methods: {
        navigateToWorld() {
            return this.$router.push(this.$locale.path('reward-info'));
        },
    },
};
</script>

<style lang="scss" scoped>
.exposition {
    // Eneble when parallax is fixed
    // transform-style: preserve-3d;

    padding-bottom: 7.5rem;

    padding-top: 4rem;
    @media screen and (min-width: 768px) {
        padding-top: 8rem;
    }

    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;

        background-image: url(https://images.dundle.com/resources/images/about-page/pattern-dundle-black.svg);
        background-position: center center;
        background-size: 125px 131px;
        opacity: 0.07;
        background-repeat: repeat;
        visibility: visible;

        // Enable when parallax is fixed
        // transform: translateZ(-3px) scale(1.8);
    }
}
img {
    border-radius: $border-radius-default;
}

.bottom-images {
    margin-top: 4.7rem;
    @media screen and (min-width: 768px) {
        margin-top: 16.667rem;
    }

    @media (min-width: 576px) and (max-width: 768px) {
        margin-top: 8rem;
        padding-right: 1rem;
    }

    .left-img {
        min-width: 100vw;
        border-radius: 0;
        @media screen and (min-width: 768px) {
            min-width: 600px;
            border-radius: $border-radius-default;
        }

        @media (min-width: 576px) and (max-width: 768px) {
            min-width: 453px;
        }
    }

    .left-column {
        @media (min-width: 576px) and (max-width: 768px) {
            padding-left: 1rem !important;
        }
    }

    .right-img {
        width: 357px;
        right: 0;
        left: 0;

        &:hover {
            cursor: pointer;
        }

        @media (min-width: 576px) and (max-width: 768px) {
            width: 270px;
        }
    }
}

.back-image {
    width: 250px;
    position: relative;
    border-radius: $border-radius-default;
    @media screen and (min-width: 786px) {
        min-width: 600px;
    }

    @media (min-width: 576px) and (max-width: 768px) {
        min-width: 463px;
    }
}

.overlay-image {
    position: absolute;
    top: 140px;
    right: 0;
    width: 224px;
    @media screen and (min-width: 786px) {
        min-width: 560px;
        top: 320px;
    }

    @media (min-width: 576px) and (max-width: 768px) {
        min-width: 344px;
    }
}

.hexagon {
    position: absolute;
    // Enable when prarallax is fixed
    // transform: translateZ(1px) scale(0.7);
    right: -35px;
    top: 85px;
    width: 58%;
    @media screen and (min-width: 768px) {
        top: 270px;
        right: 15px;
        width: 30%;
    }

    @media (min-width: 576px) and (max-width: 768px) {
        top: 104px;
        width: 35%;
        right: -15px;
    }

    &.green {
        top: -15px;
        right: 120px;
        @media screen and (min-width: 768px) {
            top: 30px;
            right: 85px;
            width: 60%;
        }
    }
}

.quote {
    margin-top: 80%;
    font-family: 'Heebo', sans-serif;
    h1 {
        font-size: 2.133rem;
        color: $color-primary-dark;
        line-height: 1.867rem;
        white-space: nowrap;
    }
    p {
        font-size: 1.333rem;
    }

    @media screen and (max-width: 320px) {
        margin-top: 90%;
        h1 {
            font-size: 1.867rem;
        }
    }

    @media screen and (min-width: 768px) {
        margin-top: 25%;
        h1 {
            font-size: 2.667rem;
            line-height: 2.333rem;
        }
    }

    @media (min-width: 576px) and (max-width: 768px) {
        margin-top: 10%;
    }
}
</style>
